import { render, staticRenderFns } from "./UserListener.vue?vue&type=template&id=00483a80&"
import script from "./UserListener.vue?vue&type=script&lang=js&"
export * from "./UserListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports